<section class="flex flex-col gap-6">
  <app-admin-page-header
    eyebrow="Contenu"
    title="Événements"
    subtitle="Gérez les sorties à venir, leur visibilité publique ou privée, et leurs informations.">
    <button (click)="openModal()" type="button"
      class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7-7v14"/>
      </svg>
      Ajouter un événement
    </button>
  </app-admin-page-header>

  <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
    <div class="px-5 py-4 border-b border-gray-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div class="relative w-full max-w-md">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
        <input type="search" [(ngModel)]="search" placeholder="Rechercher par nom ou lieu..."
          class="w-full pl-10 pr-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
        </div>
        <p class="text-xs text-gray-500 font-raleway">{{ filteredEvenements.length }} événement{{ filteredEvenements.length > 1 ? 's' : '' }}</p>
      </div>

      <ul class="divide-y divide-gray-100">
        @for (evenement of filteredEvenements; track evenement) {
          <li class="px-5 py-4 hover:bg-gray-50 transition-colors">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-3">
              <div class="flex items-center gap-4 min-w-0">
                <div class="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-100 to-indigo-200 flex items-center justify-center shrink-0 overflow-hidden">
                  @if (evenement.image) {
                    <img [src]="evenement.image" alt="" class="w-full h-full object-cover">
                  } @else {
                    <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                  }
                </div>
                <div class="min-w-0">
                  <div class="flex items-center gap-2">
                    <p class="font-raleway font-semibold text-gray-800 truncate">{{ evenement.nom }}</p>
                    @if (evenement.private) {
                      <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-amber-50 text-amber-700 text-[10px] font-semibold uppercase tracking-wider">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14v3m-3-6V7a3 3 0 116 0v4m-8 0h10c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1z"/></svg>
                        Privé
                      </span>
                    }
                    @if (!evenement.private) {
                      <span class="inline-flex items-center px-1.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-semibold uppercase tracking-wider">Public</span>
                    }
                  </div>
                  <p class="text-xs text-gray-500 truncate font-raleway">
                    {{ formatEventDate(evenement.dateDebut) }}@if (evenement.lieu) {
                    <span> · {{ evenement.lieu }}</span>
                  }
                </p>
              </div>
            </div>
            <div class="flex gap-2 shrink-0">
              <div class="relative">
                <button type="button" [id]="'dropdownButton-desktop-' + (evenement.key ?? '')" (click)="toggleDropdown(evenement.key ?? '', false)"
                  class="text-gray-700 border border-gray-300 bg-white hover:bg-gray-50 font-raleway text-sm px-4 py-2 rounded-lg inline-flex items-center gap-1.5">
                Actions
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 10 6"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/></svg>
              </button>
              <div [id]="'dropdown-desktop-' + (evenement.key ?? '')" class="z-[9999] hidden bg-white border border-gray-200 divide-y divide-gray-100 rounded-lg shadow-lg w-44 absolute mt-2" style="right: 0;">
                <ul class="py-1 text-sm text-gray-700 font-raleway" [attr.aria-labelledby]="'dropdownButton-desktop-' + (evenement.key ?? '')">
                  <li>
                    <a href="/agenda/{{ evenement.key }}" target="_blank" class="flex items-center px-4 py-2 hover:bg-gray-50">
                      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/></svg>
                      Consulter
                    </a>
                  </li>
                  <li>
                    <button (click)="onEdit(evenement)" class="flex items-center w-full px-4 py-2 hover:bg-gray-50">
                      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14.3 4.8 2.9 2.9M7 7H4a1 1 0 0 0-1 1v10c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-4.5m2.4-10a2 2 0 0 1 0 3l-6.8 6.8L8 14l.7-3.6 6.8-6.8a2 2 0 0 1 2.9 0Z"/></svg>
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button (click)="onToggleVisibility(evenement)" class="flex items-center w-full px-4 py-2 hover:bg-gray-50">
                      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                      {{ evenement.private ? 'Rendre public' : 'Rendre privé' }}
                    </button>
                  </li>
                  <li>
                    <button (click)="onDelete(evenement)" class="flex items-center w-full px-4 py-2 hover:bg-red-50 text-red-600">
                      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/></svg>
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </li>
    }
    @if (filteredEvenements.length === 0) {
      <li class="px-5 py-12 text-center text-sm text-gray-400 font-raleway">
        @if (search) {
          <span>Aucun événement ne correspond à « {{ search }} ».</span>
        }
        @if (!search) {
          <span>Aucun événement à venir.</span>
        }
      </li>
    }
  </ul>
</div>

<!-- Modal -->
<div [id]="'eventModal'" [class.hidden]="!isModalOpen" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!-- Background overlay -->
    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <!-- Modal panel -->
    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-medium leading-6 text-gray-900">{{ evenement ? 'Modifier' : 'Ajouter' }} un événement</h3>
          <button (click)="closeModal()" type="button" class="text-gray-400 hover:text-gray-500">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div #editSection>
          <form [formGroup]="evenementForm" (ngSubmit)="onSubmit()">
            <div class="space-y-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="col-span-1 md:col-span-2">
                  <label for="nom" class="block text-sm font-semibold text-gray-700 font-raleway">Nom de l'événement</label>
                  <input type="text" id="nom" formControlName="nom"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1 md:col-span-2">
                  <label for="description" class="block text-sm font-semibold text-gray-700 font-raleway">Description</label>
                  <textarea id="description" formControlName="description" rows="4"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"></textarea>
                </div>

                <div class="col-span-1">
                  <label for="dateDebut" class="block text-sm font-semibold text-gray-700 font-raleway">Date de début</label>
                  <input type="date" id="dateDebut" formControlName="dateDebut"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1">
                  <label for="heureDebut" class="block text-sm font-semibold text-gray-700 font-raleway">Heure de début</label>
                  <input type="time" id="heureDebut" formControlName="heureDebut"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1">
                  <label for="dateFin" class="block text-sm font-semibold text-gray-700 font-raleway">Date de fin</label>
                  <input type="date" id="dateFin" formControlName="dateFin"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1">
                  <label for="heureFin" class="block text-sm font-semibold text-gray-700 font-raleway">Heure de fin</label>
                  <input type="time" id="heureFin" formControlName="heureFin"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1 md:col-span-2">
                  <label for="lieu" class="block text-sm font-semibold text-gray-700 font-raleway">Lieu</label>
                  <input type="text" id="lieu" formControlName="lieu"
                      class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                      focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                </div>

                <div class="col-span-1 md:col-span-2">
                  <label for="image" class="block text-sm font-semibold text-gray-700 font-raleway">Image</label>
                  <div class="flex flex-col gap-4">
                    <input type="file" id="image" (change)="onFileSelected($event)" accept="image/*"
                        class="mt-1 block w-full px-3 py-2 bg-transparent border border-gray-300 rounded-md text-sm shadow-sm font-raleway
                        focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                    @if (imagePreview || evenementForm.get('image')?.value) {
                      <img [src]="imagePreview || evenementForm.get('image')?.value"
                        class="max-w-xs rounded-lg shadow-md" alt="Prévisualisation de l'image">
                    }
                  </div>
                </div>

                <div class="col-span-1 md:col-span-2">
                  <label class="flex items-center space-x-3">
                    <input type="checkbox" id="isPrivate" formControlName="isPrivate"
                      class="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
                    <span class="text-sm font-medium text-gray-700 font-raleway">Événement Privé</span>
                  </label>
                </div>
              </div>

              <div class="flex flex-col gap-4 sm:flex-row pt-4">
                <button type="submit"
                    class="w-full bg-blue-600 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-blue-700 font-raleway
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
                  Enregistrer
                </button>
                <button type="button" (click)="closeModal()"
                    class="w-full bg-transparent text-red-600 px-6 py-3 rounded-md text-sm font-medium border-2 border-red-600 font-raleway
                    hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors">
                  Annuler
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div [id]="'deleteModal'" [class.hidden]="!isDeleteModalOpen" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!-- Background overlay -->
    <div class="fixed inset-0 transition-opacity" aria-hidden="true">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <!-- Modal panel -->
    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Supprimer l'événement
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                Êtes-vous sûr de vouloir supprimer l'événement "{{ eventToDelete?.nom }}" ? Cette action est irréversible.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button (click)="confirmDelete()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
          Supprimer
        </button>
        <button (click)="closeDeleteModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Annuler
        </button>
      </div>
    </div>
  </div>
</div>
</section>
